module.exports = __webpack_public_path__ + "img/emoji-del.9eb99c3e.svg";